import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { CallToActionServices, GetCallToActionsParams } from "@/services/bedrock";

export const CALL_TO_ACTIONS_QUERY_KEY = "callToActions" as const;

function callToActionsQueryKey(params: GetCallToActionsParams = {}) {
  return [CALL_TO_ACTIONS_QUERY_KEY, params.playerId ?? null, params.distinct ?? false] as const;
}

export function useClearCallToActionsCache() {
  const queryClient = useQueryClient();
  return useCallback(
    () => queryClient.invalidateQueries({ queryKey: [CALL_TO_ACTIONS_QUERY_KEY] }).catch(console.error),
    [queryClient]
  );
}

export type UseCallToActionsOptions = GetCallToActionsParams & {
  enabled?: boolean;
};

export function useCallToActions({ enabled = true, playerId, distinct }: UseCallToActionsOptions = {}) {
  const query = useQuery({
    queryKey: callToActionsQueryKey({ playerId, distinct }),
    queryFn: () => CallToActionServices.getCallToActions({ playerId, distinct }),
    enabled,
  });

  return {
    ...query,
    callToActions: query.data ?? [],
  };
}
